import form from 'ngtemplate-loader!./form.tpl.html';
import list from 'ngtemplate-loader!./list.tpl.html';
import button from 'ngtemplate-loader!./button.tpl.html';
import { API } from './api';
import GuestCard from './card';
import "./styles";
export const cardWrapper = 'cardWrapper';
export const creditCard = 'creditCard';
export const chargeCard = 'chargeCard';

class WrapperClass {

  constructor($rootScope, CardAPI, StripeCard) {
    const user = $rootScope.user;
    this.canRefund = user ? user.isAdmin() : false;
    this.CardAPI = CardAPI;
    this.StripeCard = StripeCard;
  }

  totalPayments() {
    return this.cards.map(card => {
      return this.aggregateCharges(card.charges)
    }).reduce((prev, card) => prev + card, 0)
  }

  aggregateRefunds(refunds) {
    return refunds.map(refund => refund.amount).reduce((prev, refund) => prev + refund, 0)
  }

  aggregateCharges(charges) {
    return charges.map(charge => {
      const refunds = this.aggregateRefunds(charge.refunds);
      return charge.amount - refunds;
    }).reduce((prev, charge) => prev + charge, 0)
  }

  $onInit() {
    if (!this.cards) {
      this.cards = [];
    } else {
      this.cards = this.cards.map(card => {
        const guestCard = new GuestCard(this.customer, card);
        guestCard.setAPI(this.CardAPI);
        return guestCard;
      });
    }
    this.card = new this.StripeCard(this.card || {});
  }
}

class CreditCard {

  /* @ngInject */
  constructor($scope, $filter, $element, $timeout, $animate, StripeCard, CardAPI, $rootScope, $http, $location) {
    const vm = this;
    const user = $rootScope.user;
    this.CardAPI = CardAPI;
    this.$scope = $scope;
    this.$filter = $filter;
    this.$elm = $element;
    this.$timeout = $timeout;
    this.StripeCard = StripeCard;
    this.focused = false;
    this.$http = $http;
    this.company = user ? user.activeCompany() : { _id: $location.$$search.id };
    this._intent = undefined;
    this.cardsExpanded = false;
    this.canRefund = user ? user.isAdmin() : false;

    $animate.on('addClass', $element, (elm, evtName, trans) => {
      if (evtName === 'start') {
        switch (true) {
          case elm[0].classList.contains('CC'):
            if (trans.addClass === 'showCards') {
              this.newCardFields.style.top = `${this.existingCardsHeight - 3}px`;
            }
            this.parentElm.style.height = `${this.height}px`;
            break;
        }
      }
    });

    $animate.on('removeClass', $element, (elm, evtName) => {
      if (elm[0].classList.contains('Billing')) {
        switch (evtName) {
          case 'start':
            elm.addClass('closing');
            this.parentElm.style.height = `${this.height}px`;
            break;
          case 'close':
            $timeout(() => {
              elm.removeClass('closing');
            }, 500)
            break;
        }
      }
    });

  }

  selectField(e) {
    const { target } = e;
    target.setSelectionRange(0, target.value.length)
    target.classList.add('selected')
  }

  focus(query) {
    document.querySelector(query).focus();
  }

  get validate() {
    const parent = this;
    return {
      changeField: (e, count) => {
        const { target } = e;
        const { value, id } = target;
        switch (id) {
          case 'exp_month':
            if (value.length === count) {
              parent.focus('#exp_year');
            }
            break;

          default:
            break;
        }
      },
      actionKey: (e) => {
        const { key } = e;
        const isAction = ['Tab', 'Backspace', 'Delete'].includes(key);
        return isAction ? key : undefined;
      },
      allowedKey: (e) => {
        const { code, key } = e;
        const isAction = this.validate.actionKey(e);
        const isValidKey = key.match(/^[0-9]/) || isAction;
        return isValidKey ? key : undefined;
      },
      number: (e) => {
        if (this.form['payment.number'].$error.number) {
          this.form['payment.number'].$setValidity('number', true);
          this.card.error = undefined;
          this.card.token = undefined;
        }
      },
      month: (e) => {
        const code = this.validate.allowedKey(e);
        if (!code) return e.preventDefault();
        const entry = (this.card.exp_month ? this.card.exp_month.toString() : '') + e.key;
        if (e.target.classList.contains('selected')) {
          e.target.value = '';
          e.target.classList.remove('selected');
        } else {
          if (this.validate.actionKey(e)) {

          } else {
            if (parseInt(entry, 10) > 12 && (code !== 'Delete' || code !== 'Backspace')) {
              e.preventDefault();
            }
          }
        }
      },
      year: (e, validateOnly = false) => {
        const code = this.validate.allowedKey(e);
        let year = (this.card.exp_year ? this.card.exp_year.toString() : '');
        if (!code) return e.preventDefault();
        if (validateOnly) {
          const date = new Date();
          const thisYear = Number.parseInt(date.getFullYear().toString().substr(2, 2), 10);
          year = Number.parseInt(year);
          if (year < thisYear) {
            this.form['payment.exp_year'].$setValidity('expiration', false);
          } else {
            this.form['payment.exp_year'].$setValidity('expiration', true);
          }
        } else {
          if (e.target.classList.contains('selected')) {
            e.target.value = '';
            e.target.classList.remove('selected');
          } else {
            if (year.length === 2 && e.keyCode !== 8 && e.keyCode !== 9) {
              e.preventDefault();
            }
          }
        }
      }

    }
  }

  get newCardFields() {
    return this.parentElm.querySelector('.newCard');
  }

  get height() {
    let height = this.initHeight;
    if (this.cardsExpanded) {
      height += this.existingCardsHeight;
    }
    if (this.focused) {
      height += this.billingHeight;
    } else {
      height += 20;
    }

    return height;
  }


  showCards() {
    this.$timeout(() => {
      this.cardsExpanded = true;
    })
  }

  intent(ms) {
    if(!this._intent) return false;
    return (Date.now() - this._intent) >= ms;
  }

  get existingCardsHeight() {
    return this.parentElm.querySelector('.existing').offsetHeight;
  }


  $onInit() {

    if (this.buyer && this.buyer.name) this.prevName = this.buyer.name;

    this.cards = this.parent.cards;

    this.card = new this.StripeCard(this.card || {});

    this.theme = this.parent.theme || 'modular';

    const fields = this.$elm[0].querySelector('.CreditCard').querySelectorAll('.form-control');
    const elm = this.$elm[0];

    let checkTimer;

    const startTimer = (cb) => {
      checkTimer = setInterval(cb, 50);
    }

    const stopTimer = () => {
      clearInterval(checkTimer);
      checkTimer = undefined;
    }
    
    const expandControl = (e) => {
      const xBounds = e.offsetX > 15 && e.offsetX < 390;
      const yBounds = e.offsetY > 0 && e.offsetY < 7;
      if (xBounds && yBounds && !this.cardsExpanded && this.cards && this.cards.length) {
        if(!this._intent) {
          document.body.style.cursor = 'pointer';
          this._intent = Date.now();
          if (!checkTimer) startTimer(() => {
            const intent = this.intent(500);
            if (intent) {
              stopTimer();
              document.body.style.cursor = 'default';
              this.showCards();
            }
          });
        }
      } else {
        this._intent = undefined;
        document.body.style.cursor = 'default';
        stopTimer()
      }
    }

    const resetIntent = (e) => {
      this._intent = undefined;
      stopTimer()
    }

    elm.addEventListener('mouseover', expandControl, false)
    elm.addEventListener('mousemove', expandControl, false)
    elm.addEventListener('mouseleave', resetIntent, false)


    const focusListener = (e) => {
      this.$timeout(() => {
        this.focused = true;
      });
    }

    const blurListener = (e) => {
      this.$timeout(() => {
        try {
          const parent = document.activeElement.parentElement.parentElement.parentElement.parentElement;
          const isCardField = parent.classList.contains('CreditCard') || parent.tagName === 'CREDIT-CARD' || parent.getAttribute('name') === 'Card' || parent.querySelector('.CreditCard');
          if (!isCardField && !isBillingField) this.focused = false;
        } catch (error) {
          this.focused = false;
        }
      });
    }

    fields.forEach(field => {
      field.addEventListener('focus', focusListener)
      field.addEventListener('blur', blurListener)
    });

    if(this.email) {
      this.card.email = this.email;
    }

    this.card.amount = this.amount > 0 ? this.amount : undefined;

    this.$timeout(() => {
      const parent = this.parentElm = this.$elm[0].querySelector('[name="Card"]');
      this.creditCardHeight = parent.querySelector('.CreditCard').offsetHeight;
      this.billingHeight = parent.querySelector('.Billing').offsetHeight;
      this.initHeight = this.creditCardHeight;
      this.parentElm.style.height = `${this.height}px`;
    });


  }

  $doCheck() {
    if((this.parent.buyer && this.parent.buyer.name) && !this.card.name) this.card.name = angular.copy(this.parent.buyer.name);
  }

  $onChanges(changed) {
    if(changed.amount) {
      this.card = this.card || new this.StripeCard({});
      this.card.amount = changed.amount.currentValue > 0 ? changed.amount.currentValue : undefined;
    }
  }

}

class ListClass {

  ccImage(card) {
    switch (card.type) {
      case 'American Express':
      case 'amex':
        return '/assets/images/cards/amex.svg';
      case 'Visa':
      case 'visa':
      case 'v':
        return '/assets/images/cards/visa.svg';
      case 'MasterCard':
      case 'mc':
        return '/assets/images/cards/mastercard.svg';
      case 'Discover':
      case 'discover':
        return '/assets/images/cards/discover.svg';
      case 'Diners-Club':
        return '/assets/images/cards/diners-club.svg';
    }
  }

  use(card) {
    if (card.isActive) {
      card.isActive = false;
      this.activeCard = undefined;
      this.focused = false;
    } else {
      card.isActive = true;
      this.activeCard = card;
      this.focused = true;
    }
  }

  $onInit() {
    this.aggregateCharges = this.parent.aggregateCharges;
    this.aggregateRefunds = this.parent.aggregateRefunds;
    this.canRefund = this.parent.canRefund;
    this.cards = this.parent.cards || [];
  }

}

class Submit {
  constructor($scope, $filter, $element, $timeout, $animate, StripeCard, CardAPI, $rootScope, $http, $location) {
    const vm = this;
    const user = $rootScope.user;
    this.CardAPI = CardAPI;
    this.$scope = $scope;
    this.$filter = $filter;
    this.$elm = $element;
    this.$timeout = $timeout;
    this.StripeCard = StripeCard;
    this.focused = false;
    this.$http = $http;
    this.company = user ? user.activeCompany() : { _id: $location.$$search.id };
    this._intent = undefined;
  }

  assignToken() {
    const card = angular.copy(this.card);
    delete card.amount;
    delete card.email;
    return new Promise((resolve, reject) => {
      return card.Create((res) => {
        this.checking = false;
        this.card.token = res.id;
        resolve(res.id);
      }, reject);
    })
  }

  charge() {

    this.charging = true;

    const existing = this.customer;
    const fn = existing ? this.updateCustomer : this.precharge ? (token) => { return { token } } : this.createCustomer;

    const chargeFn = (card) => {
      card.setAPI(this.CardAPI, this.company._id);
      return card.charge(this.parent.amount).then(() => {
        this.card = {
          amount: this.parent.amount
        }
        this.postCharge();
        this.charging = false;
        return card;
      }).catch(console.error);
    };

    if (this.activeCard) {
      chargeFn(this.activeCard).then(card => {
        console.log(this.cards);
      })
    } else {

    this.assignToken()
      .then(fn.bind(this))
      .then((response) => {
        console.log(this.card)
        if (this.precharge) {
          this.$timeout(() => {
            this.card.charges = [];
            // pass to save method
            this.cards.push(this.card);
            this.postCharge();

          });
        } else {

          const res = response.data;
          const error = res.error;
          if (error) {
            this.$timeout(() => {
              switch (error) {
                case `Your card's security code is incorrect.`:
                  this.form['payment.cvv'].$setValidity('cvv', false);
                  this.card.error = error;
                  break;
                case `Your card has expired.`:
                  this.form['payment.exp_year'].$setValidity('expiration', false);
                  this.card.error = error;
                  break;
                default:
                  this.form['payment.number'].$setValidity('number', false);
                  this.card.error = error;
              }
            });
          } else {
            this.$timeout(() => {

              this.customer = res.id;

              const source = res.sources.data[0];

              const card = new GuestCard(res.id, {
                id: source.id,
                type: source.brand,
                masked: source.last4,
                charges: []
              });

              card.setAPI(this.CardAPI, this.company._id);

              this.cards.push(card)
              // clear the form
              this.card.number = "";
              this.card.exp_month = "";
              this.card.exp_year = "";
              this.card.cvc = "";

              if (this.precharge) {
                // if gift we need to just save and charge during the process.
                console.log(card);
                // chargeFn(card);
              } else {
                this.$timeout(() => {
                  this.postCharge();

                })
              }

            });
          }

        }
      });

    }

  }

  get customer() {
    return this.parent.customer;
  }

  set customer(customer) {
    this.parent.customer = customer;
  }

  updateCustomer(token) {
    return this.$http({
      method: 'PUT',
      url: `${window.rezflow.api_url}/customer/${this.customer}`,
      headers: {
        'Company': this.company._id,
        'bypass': true
      },
      data: {
        source: token,
      }
    });
  }

  createCustomer(token) {
    return this.$http({
      method: 'POST',
      url: `${window.rezflow.api_url}/customer`,
      headers: {
        'Company': this.company._id,
        'bypass': true
      },
      data: {
        source: token,
        email: this.card.email,
        metadata: {
          type: 'gift'
        }
      }
    });
  }

  $doCheck() {}

  $onInit() {
    this.card = new this.StripeCard(this.parent.card || {});
    this.cards = this.parent.cards;
    this.customer = this.parent.customer;
    this.amount = this.parent.amount;
    this.precharge = this.precharge === undefined ? true : this.precharge;
  }
}

export default (MODULE) => {
  API(MODULE);
  angular.module(MODULE)
    .component(cardWrapper, {
      transclude: true,
      bindings: {
        cards: '=',
        card: '=entry',
        customer: '=',
        theme: '<',
        buyer: '<',
        email: '<',
        amount: '<',
        postCharge: '&',
        submitLabel: '@?',
        options: '<',
      },
      template: '<div><ng-transclude></ng-transclude></div>',
      controller: WrapperClass,
      controllerAs: '$credit'

    })
    .component('cardList', {
      require: {
        parent: `^${cardWrapper}`,
      },
      templateUrl: list,
      bindings: {
        postCharge: '&'
      },
      controller: ListClass
    })
    .component(creditCard, {
      require: {
        parent: `^${cardWrapper}`,
      },
      bindings: {
        card: '=',
      },
      templateUrl: form,
      controller: CreditCard
    })
    .component(chargeCard, {
      require: {
        parent: `^${cardWrapper}`,
      },
      bindings: {
        precharge: '<',
        postCharge: '&',
        submitLabel: '@',
        disabled: '=',
        btnClass: "@",
        form: '<',
        card: '='
      },
      templateUrl: button,
      controller: Submit
    });

  return name;

};


// WEBPACK FOOTER //
// ./client/assets/scripts/modules/card/index.js